module.exports = __webpack_public_path__ + "img/nextIcon.c2bfcce8.svg";